import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  TextField,
  Stack,
  Alert,
  InputAdornment,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import postApiData from "../../../../hooks/apiRequests/postsRequest";
import { theme } from "../../../../configs/theme";
import { useToast } from "../../../shared/toastMessages/toastProvider";
import AuthCard, { authButtonSx, authFieldSx } from "../../common/authCard";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { showToast } = useToast();

  useEffect(() => {
    setSubmitted(false);
  }, []);

  const resetPassword = async (event) => {
    event.preventDefault();
    if (!email.trim()) {
      showToast("Please enter your email", "error");
      return;
    }

    setSubmitting(true);
    try {
      const response = await postApiData("/Send/PasswordReset", {
        email: email.trim(),
      });
      if (response?.data) {
        showToast("User Password Reset Sent Successfully!", "success");
      } else {
        showToast("Unable to send Reset Password request", "error");
      }
    } catch (error) {
      showToast("Unable to send Reset Password request", "error");
    } finally {
      setSubmitting(false);
      setSubmitted(true);
    }
  };

  return (
    <AuthCard
      title="Reset password"
      subtitle={
        submitted
          ? "Check your inbox for the next steps."
          : "Enter your email and we’ll send a reset link if an account exists."
      }
      footerTitle="Have an account?"
      footerActionLabel="Back to login"
      onFooterAction={() => navigate("/")}
    >
      {!submitted ? (
        <Stack component="form" spacing={2} onSubmit={resetPassword}>
          <TextField
            id="email"
            label="Email"
            type="email"
            autoComplete="email"
            theme={theme}
            variant="outlined"
            size="small"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={authFieldSx}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailOutlinedIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            variant="contained"
            theme={theme}
            disabled={submitting}
            fullWidth
            sx={authButtonSx}
          >
            {submitting ? "Sending..." : "Send reset email"}
          </Button>
        </Stack>
      ) : (
        <Stack spacing={2}>
          <Alert severity="success" sx={{ borderRadius: "10px" }}>
            If that email is registered, a password reset message has been sent.
            Please check your inbox.
          </Alert>
          <Button
            onClick={() => navigate("/")}
            variant="contained"
            theme={theme}
            fullWidth
            sx={authButtonSx}
          >
            Back to login
          </Button>
        </Stack>
      )}
    </AuthCard>
  );
};

export default ResetPassword;
